import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { compose } from "recompose";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import { Paper, Typography, Button, withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import AudioPlayer from "../../../../components/AudioPlayer";
import { Tipografia, Flex } from "../../../../_common";
import ReadMore from "../../../../_common/components/ReadMore/ReadMore";
import ScoreDeSimilaridade from "../../../../_common/containers/ScoreDeSimilaridade/ScoreDeSimilaridade";
import ButtonFeedbackLigacao from "./ButtonFeedbackLigacao";
import { onOpenModalFeedbackLigacao as onOpenModalFeedbackLigacaoAction } from "../../../../store/reducers/feedbackLigacao/reducer";
import LinkAnaliseLigacao from "../../../analise-ligacao/Components/LinkAnaliseLigacao";

const styles = {
  textoEvento: { display: "flex", flexDirection: "column", height: "100%", width: "100%", padding: "8px 8px 0px 8px" },
  texto: { whiteSpace: "pre-line", paddingBottom: 3, wordBreak: "break-word" },
  linkLigacao: { color: "#457AB7 !important", marginTop: "auto" },
  smallIcon: {
    width: 18,
    height: 18,
  },
  small: {
    width: 24,
    height: 24,
    padding: 0,
    margin: "auto 0px 0px auto",
  },
  textoResponsavel: { whiteSpace: "pre-line" },
  estrelaSmall: {
    fontSize: 21,
  },
  iconeEstrelaPreenchida: {
    color: "gold !important",
  },
  iconeEstrelaVazia: {
    backgroundColor: "white !important",
  },
  iconeGerente: {
    width: 20,
    height: 20,
  },
  readMoreTipografia: {
    overflowWrap: "break-word",
  },
};

function TimeLineItemEvento({
  evento,
  podeAbrirLigacoes,
  index,
  onOpenModalFeedbackLigacao,
  match,
  classes,
  isLinkPublico,
  isTimelineAtividades,
}) {
  const intl = useIntl();
  const dadosLigacao = evento.caminhoLigacao && evento.duracaoLigacao;
  const mostraAnalise = dadosLigacao && evento.podeAcessarAnaliseLigacao && podeAbrirLigacoes;
  const mostraAudioLinkPublico = dadosLigacao && isLinkPublico;

  let mostraAudioNaTimeline = podeAbrirLigacoes && !!dadosLigacao;

  if (mostraAudioNaTimeline && !evento.ligacaoViaApi) {
    mostraAudioNaTimeline = !evento.mostraFeedbackLigacao && !evento.podeAcessarAnaliseLigacao;
  }

  const isComentarioGerente = evento.isUsuarioGerente && evento.tipoEventoTimelineId === 4;

  return (
    <Paper className={classes.textoEvento} id="divTimeLine" elevation={isTimelineAtividades ? 0 : 1}>
      <Flex alignItems="center" style={{ paddingBottom: 5 }}>
        <Tipografia
          tipo="notaLegendas"
          cor="darkSecondaryText"
          className={classes.textoResponsavel}
          id={`lblResponsavel-${index}`}
        >
          {isComentarioGerente && "Gerente "}
          {evento.usuarioNome}
        </Tipografia>
        {isComentarioGerente && <BookmarkBorderIcon style={styles.iconeGerente} color="action" />}
      </Flex>
      {evento.texto && (
        <ReadMore
          lines={isTimelineAtividades ? 3 : 2}
          TipografiaProps={{ className: classes.readMoreTipografia }}
          id={`lblcomentario-${index}`}
        >
          {evento.texto.split("\n").map(linha => (
            <React.Fragment key={linha}>
              {linha}
              <br />
            </React.Fragment>
          ))}
        </ReadMore>
      )}
      {evento.observacoes &&
        !isTimelineAtividades && (
          <Typography color="darkSecondaryText">
            {intl.formatMessage({ defaultMessage: "Observações:" })} {evento.observacoes}
          </Typography>
        )}
      {!!evento.scoreSimilaridade &&
        evento.scoreSimilaridade > 0 &&
        !isTimelineAtividades && (
          <Flex alignItems="center">
            <Tipografia>{intl.formatMessage({ defaultMessage: "Score de similaridade:" })}</Tipografia>
            <Tipografia>
              <ScoreDeSimilaridade score={evento.scoreSimilaridade} />
            </Tipografia>
          </Flex>
        )}
      {evento.linkReuniao &&
        !isTimelineAtividades && (
          <Flex alignItems="center" justifyContent="flex-end" style={{ marginTop: 10 }}>
            <Button color="primary" id="btn-link-reuniao" href={evento.linkReuniao} target="_blank">
              {intl.formatMessage({ defaultMessage: "Link da Reunião" })}
            </Button>
          </Flex>
        )}
      {(mostraAudioNaTimeline || mostraAudioLinkPublico) &&
        !isTimelineAtividades && <AudioPlayer source={evento.caminhoLigacao} duration={evento.duracaoLigacao} />}

      <Flex
        flexDirection="row"
        alignItems="flex-end"
        justifyContent="flex-end"
        style={{ paddingTop: 4, paddingBottom: 4 }}
      >
        {mostraAnalise &&
          !isTimelineAtividades && (
            <LinkAnaliseLigacao
              historicoLigacaoId={evento.historicoLigacaoId}
              usuarioIdLigacao={evento.usuarioId}
              mostraFeedbackLigacao={evento.mostraFeedbackLigacao}
            />
          )}
        {evento.mostraFeedbackLigacao &&
          podeAbrirLigacoes &&
          !evento.podeAcessarAnaliseLigacao &&
          !isTimelineAtividades && (
            <ButtonFeedbackLigacao
              label={evento.labelBotaoFeedbackLigacao}
              qtdNaoLidos={evento.feedbackLigacaoQtdNaoLidos}
              onClick={() =>
                onOpenModalFeedbackLigacao({
                  feedbackLigacaoId: evento.feedbackLigacaoId,
                  historicoLigacaoId: evento.historicoLigacaoId,
                  leadId: match.params.leadId,
                })
              }
            />
          )}
      </Flex>
    </Paper>
  );
}

TimeLineItemEvento.propTypes = {
  evento: PropTypes.object,
  podeAbrirLigacoes: PropTypes.bool,
  onOpenModalFeedbackLigacao: PropTypes.func,
  classes: PropTypes.object,
  index: PropTypes.number,
  match: PropTypes.object,
  isLinkPublico: PropTypes.bool,
  isTimelineAtividades: PropTypes.bool,
};

const withConnect = connect(
  null,
  { onOpenModalFeedbackLigacao: onOpenModalFeedbackLigacaoAction }
);

const enhance = compose(
  withStyles(styles),
  withConnect,
  withRouter
);

export default enhance(TimeLineItemEvento);
